<template>
  <div class="flex justify-center items-center py-8">
    <div class="flex gap-1.5">
      <span
        v-for="i in 5"
        :key="i"
        class="tile-loader w-9 h-9 border-2 rounded"
        :style="{ animationDelay: `${(i - 1) * 0.12}s` }"
      ></span>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
/* Echoes the in-game crossword reveal: each tile ripples from the empty
   board state to the teal->green "found" gradient in a looping wave. */
.tile-loader {
  background-color: #1f2937; /* gray-800 */
  border-color: #4b5563;     /* gray-600 */
  animation: tile-reveal 1.4s ease-in-out infinite;
}

@keyframes tile-reveal {
  0%, 70%, 100% {
    background-color: #1f2937;
    border-color: #4b5563;
    transform: rotateX(0);
  }
  35% {
    background-image: linear-gradient(to bottom right, #2dd4bf, #22c55e);
    border-color: transparent;
    transform: rotateX(0);
  }
  20% {
    transform: rotateX(-90deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .tile-loader {
    animation: tile-pulse 1.4s ease-in-out infinite;
  }
  @keyframes tile-pulse {
    0%, 70%, 100% { opacity: 0.4; }
    35% { opacity: 1; }
  }
}
</style>
